globalThis.global = globalThis;
globalThis.process ||= { env: {} };
